import { useState, useEffect, useContext } from "react";
import { Row, Col, Container } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "../components/LandingPage.css";
import VN from "../components/VN";
import { UserDataContext } from "../components/UserDataContext";
import "../components/button.css";
import Alerts from "../components/Alerts";
import { Typography, Box, Paper, InputAdornment, Button } from "@mui/material";
import img4 from "../images/Oldpeople.jpg";
import soon from "../images/soon1.png";
import layout from "../config/layout";
import { apiRequest } from "../services/apiService";
//import { fetchUserData } from "../components/auth";
import { fetchUserData } from "../services/userService";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import SearchIcon from "@mui/icons-material/Search";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import LoginForm from "../components/login/LoginForm";
import HeroSection from "../components/login/HeroSection";
import { login, getLoginError } from "../services/authService";

import "@fontsource/lato/300.css";
import "@fontsource/lato/400.css";
import "@fontsource/lato/700.css";

const Login = () => {
  const [user, setUser] = useState("");
  const [password, setPassword] = useState("");
  const [apiResponse, setApiResponse] = useState({});
  const navigate = useNavigate();
  const { userData, setUserData } = useContext(UserDataContext);
  const [show, setShow] = useState(false);
  const [showApiResponse, setShowApiResponse] = useState(false);
  const [fadeOut, setFadeOut] = useState(false);
  const ClearApiResponse = () => {
    setShowApiResponse(false);
  };
  useEffect(() => {
    // Blokada dla środowiska deweloperskiego (localhost)
    if (process.env.NODE_ENV === "development") {
      return;
    }

    const sendIpToApi = async () => {
      try {
        const ipResponse = await fetch("https://api.ipify.org?format=json");
        if (!ipResponse.ok) throw new Error("Nie udało się pobrać IP");
        const ipData = await ipResponse.json();
        const userIp = ipData.ip;
        const response = await apiRequest("send-email-entry", "POST", {
          ip: userIp,
        });
        console.log("OK", response);
      } catch (error) {
        console.error("Błąd podczas pobierania lub wysyłania IP:", error);
      }
    };

    sendIpToApi();
  }, []);
  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const response = await login(user, password);
      setUserData(response);
      const group = response.group;
      const type = response.type;

      if (response.error_msg === 200) {
        if (group === 1) navigate("/admin");
        if (group === 2) console.log("Weryfikacja");
        if (group === 3) navigate("/profile");
        if (type === 2) navigate("/seeker");
      }

      const error = getLoginError(response.error_msg);

      if (error) {
        setApiResponse(error);
        setShowApiResponse(true);
      }
    } catch (error) {
      setApiResponse({
        title: "Błąd",
        severity: "error",
        info: "Błąd podczas wysyłania danych.",
      });
      setShowApiResponse(true);
      navigate("/nopermission");
    }
  };

  useEffect(() => {
    const verifyUser = async () => {
      try {
        await fetchUserData();
      } catch (error) {
        console.error("Błąd podczas weryfikacji użytkownika:", error);
      }
    };
    verifyUser();
  }, [navigate, setUserData]);

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      handleSubmit(event);
    }
  };

  const handleShow = () => {
    setShow(!show);
  };

  const handleFind = () => {
    console.log("Logged: ", userData?.userId);
    if (userData?.userId === undefined || userData?.userId === 0) {
      setApiResponse({
        title: "Błąd",
        severity: "error",
        info: "Musisz być zalogowany, by wyświetlać opiekunki",
      });

      setShowApiResponse(true);
      setFadeOut(false);

      setTimeout(() => {
        setFadeOut(true);
      }, 4000);

      setTimeout(() => {
        setShowApiResponse(false);
        setFadeOut(false);
      }, 5000);
    }
  };

  return (
    <div
      style={{
        fontFamily: "'Lato', sans-serif",
        backgroundColor: "#fafafa",
        minHeight: "100vh",
      }}
    >
      <VN />

      {showApiResponse && (
        <Row className="sticky-alerts-container">
          <Alerts data={apiResponse} />
        </Row>
      )}

      <Container style={{ paddingTop: "20px" }}>
        {/* NAGŁÓWEK I PANEL LOGOWANIA */}
        <LoginForm
          user={user}
          password={password}
          setUser={setUser}
          setPassword={setPassword}
          handleSubmit={handleSubmit}
          handleKeyDown={handleKeyDown}
          clearApiResponse={ClearApiResponse}
        />

        {/* SEKCJA GŁÓWNA (TEKST + ZDJĘCIE) */}
        <HeroSection />
        <Row className="align-items-start">
          <Col lg={7} md={12} className="mb-4 mb-lg-0">
            <Box sx={{ position: "relative", mb: 4 }}>
              <Typography
                variant="h6"
                component="p"
                sx={{
                  color: "#455a64",
                  fontWeight: 400,
                  lineHeight: 1.7,
                  fontSize: "1.2rem",
                  position: "relative",
                  zIndex: 2,
                }}
              >
                Wiemy, jak trudno powierzyć bliską osobę komuś obcemu. <br />
                Dlatego każda opiekunka w naszym serwisie przechodzi{" "}
                <strong>indywidualną, rzetelną weryfikację</strong>. <br />
                Sprawdzamy doświadczenie, dokumenty i referencje – abyś miał
                absolutną pewność, że Twoi bliscy są w najlepszych rękach.
              </Typography>

              {/* Tło znaku wodnego "Soon" */}
              <img
                src={soon}
                alt="Wkrótce"
                style={{
                  position: "absolute",
                  top: "-10%",
                  left: "5%",
                  width: "75%",
                  opacity: 0.12,
                  transform: "rotate(-10deg)",
                  pointerEvents: "none",
                  zIndex: 1,
                }}
              />
            </Box>

            {/* AKCJE I BUTTONY */}
            <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap", mb: 4 }}>
              <Button
                variant="contained"
                color="success"
                size="large"
                onClick={handleFind}
                startIcon={<SearchIcon />}
                sx={{
                  fontWeight: 600,
                  textTransform: "none",
                  borderRadius: "10px",
                  px: 3,
                  py: 1.5,
                  boxShadow: "0 4px 14px rgba(46, 125, 50, 0.25)",
                }}
              >
                Znajdź zweryfikowaną opiekunkę
              </Button>

              <Button
                variant="outlined"
                color="primary"
                size="large"
                onClick={handleShow}
                startIcon={<VerifiedUserIcon />}
                sx={{
                  fontWeight: 600,
                  textTransform: "none",
                  borderRadius: "10px",
                  px: 3,
                  py: 1.5,
                }}
              >
                {show
                  ? "Ukryj proces weryfikacji"
                  : "Sprawdź jak weryfikujemy opiekunki"}
              </Button>
            </Box>
            {show && (
              <Paper
                elevation={0}
                sx={{
                  p: 3,
                  backgroundColor: "#e8f5e9",
                  borderRadius: "16px",
                  borderLeft: "5px solid #2e7d32",
                  boxShadow: "0px 4px 20px rgba(0,0,0,0.03)",
                }}
              >
                <Typography
                  variant="h6"
                  sx={{ fontWeight: 700, color: "#1b5e20", mb: 2 }}
                >
                  Rzetelna weryfikacja przed dołączeniem do serwisu
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ color: "#2e7d32", mb: 3, fontWeight: 500 }}
                >
                  Każda kandydatka przechodzi restrykcyjny proces sprawdzania
                  przez wykwalifikowany personel.
                </Typography>

                <Row className="g-3">
                  {[
                    "Tożsamość i niekaralność użytkownika",
                    "Udokumentowane doświadczenie w opiece",
                    "Pozytywne referencje od poprzednich rodzin",
                    "Kwalifikacje, dyplomy oraz odbyte kursy medyczne",
                    "Indywidualna rozmowa kwalifikacyjno-weryfikacyjna",
                  ].map((text, i) => (
                    <Col
                      xs={12}
                      sm={6}
                      key={i}
                      className="d-flex align-items-center"
                    >
                      <CheckCircleIcon
                        sx={{ color: "#2e7d32", mr: 1.5, fontSize: 20 }}
                      />
                      <Typography
                        variant="body2"
                        sx={{ color: "#37474f", fontWeight: 600 }}
                      >
                        {text}
                      </Typography>
                    </Col>
                  ))}
                </Row>

                <Box
                  sx={{
                    mt: 3,
                    pt: 2,
                    borderTop: "1px style solid rgba(46,125,50,0.1)",
                  }}
                >
                  <Typography
                    variant="caption"
                    sx={{
                      color: "#1b5e20",
                      fontWeight: 700,
                      textTransform: "uppercase",
                      letterSpacing: "0.5px",
                    }}
                  >
                    Gwarancja pewności i bezpieczeństwa wyboru
                  </Typography>
                </Box>
              </Paper>
            )}
          </Col>
          <Col
            lg={5}
            md={12}
            className="d-flex justify-content-center justify-content-lg-end"
          >
            <Paper
              elevation={0}
              sx={{
                p: 2,
                backgroundColor: "#fff",
                border: "1px solid #e0e0e0",
                borderRadius: "16px",
                boxShadow: "0px 10px 30px rgba(0, 0, 0, 0.06)",
                maxWidth: "400px",
                width: "100%",
                transition: "transform 0.3s",
                "&:hover": { transform: "scale(1.02)" },
              }}
            >
              <img
                src={img4}
                alt="Moi Rodzice"
                style={{
                  width: "100%",
                  height: "auto",
                  borderRadius: "10px",
                  display: "block",
                }}
              />
            </Paper>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Login;
